import React, { useState } from 'react'
import { Flex, VStack } from '@chakra-ui/react'
import EvaluationsTable from '../../../components/tables/EvaluationsTable'


const EvaluationsPage = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(event.currentTarget.scrollTop > 0)
  }

  return (
    <Flex
      flexDirection={{ base: 'column', md: 'row' }}
      height="100%"
      overflowY="auto"
      onScroll={handleScroll}
      borderRadius={isScrolled ? '10px' : '0'}
    >
      <VStack gap={{ base: '12px', md: '16px' }} width="100%">
        <EvaluationsTable />
      </VStack>
    </Flex>
  )
}

export default EvaluationsPage
